import React, { useState, useContext, useEffect, useRef } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from "react-i18next";
import { DataContext } from "../App";
import { NavLink } from "react-router-dom";

const SearchFilter = ({ closeMenu }) => {
    const [query, onChangeQuery] = useState("");
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const context = useContext(DataContext);
    const { t } = useTranslation();
    const searchContainerRef = useRef(null);

    const handleClickOutside = (event) => {
        if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
            setIsSearchVisible(false);
            onChangeQuery("");
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div ref={searchContainerRef}>
            <div className="input-group search">
                <input
                    type="text"
                    className="form-control br-0 searchCustom search-transparent text-white"
                    placeholder={t("FindProperty")}
                    aria-label={t("FindProperty")}
                    aria-describedby="search-property"
                    onFocus={() => setIsSearchVisible(true)}
                    onChange={(event) => onChangeQuery(event.target.value)}
                />
                <span className="input-group-text br-0 transparent-icon-search" id="Search-concierge">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                </span>
            </div>
            {isSearchVisible && (
                <div className="search search-filter">
                    <div className="searchCustomData">
                        {context.properties &&
                            context.properties
                                .filter((x) => {
                                    if (query === '') {
                                        return false;
                                    }
                                    return x.name.toLowerCase().includes(query.toLowerCase()) && x.status === "active";
                                })
                                .map((x, index) => (
                                    <NavLink
                                        key={index}
                                        to={`/property-collection/${x.seoInformation.linkUrl}`}
                                        className="lineEffectBlack"
                                        target="_self"
                                        onClick={() => {
                                            closeMenu();
                                            onChangeQuery("");
                                            setIsSearchVisible(false);
                                        }}
                                    >
                                        {x.name}
                                    </NavLink>
                                ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchFilter;
